const JcyyRoute = [
  {
    path: '/jcyy',// 我的检查预约
    component: () => import('./views/index')
  },
  {
    path: '/jcyy/detail',// 检查预约详情
    component: () => import('./views/detail')
  },
  {
    path: '/jcyy/apply',// 选择预约时间
    component: () => import('./views/apply')
  },
  {
    path: '/jcyy/result',// 预约结果
    component: () => import('./views/result')
  }
]

export default JcyyRoute



// WEBPACK FOOTER //
// ./src/page/jcyy/jcyyRoute.js